import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import {
  ADJUST_PLACEMENTS,
  downloadModalQrTrackerLink,
  downloadQrLinkForVisit,
  withAdjustCreative
} from '../utils/adjust-page-tag';

// SEOENG-186: a live download QR in place of the static QR image, so every scan reaches Adjust
// with a creative (the placement) and, on an organic visit, the page. The first render (server
// and client alike) encodes the QR tracker with the placement as its creative; once mounted it
// is tagged for the visit, exactly as the download modal's QR is.
const AdjustDownloadQrCode = ({ placement = '', appKind = 'gti', size = 90, className = '' }) => {
  const [value, setValue] = useState(() =>
    withAdjustCreative(downloadModalQrTrackerLink(appKind), placement || ADJUST_PLACEMENTS.BODY)
  );

  useEffect(() => {
    setValue(downloadQrLinkForVisit(appKind, placement));
  }, [appKind, placement]);

  return <QRCode className={className} value={value} size={size} />;
};

export default AdjustDownloadQrCode;
